import React from "react";
import PrivacyPolicy from "../components/privacy_policy/privacy";
import { Helmet } from "react-helmet-async";
import Hero from "../components/privacy_policy/Hero";
const PrivacyPolicyPage = () => {
  return (
    <>
      {/*metadata for SEO */}
      <Helmet>
        <title>Privacy Policy | DevAngles</title>
        <meta name="description" content="Your privacy is our priority. Learn how DevAgles handles your personal data and your privacy rights." />
        
        <link rel="canonical" href="https://www.devangles.com/privacy-policy/" />
        <link rel="dns-prefetch" href="https://www.devangles.com" />
        <link rel="dns-prefetch" href="//fonts.googleapis.com" />
      </Helmet>
      <Hero/>
      <PrivacyPolicy />
       

    </>
  );
};

export default PrivacyPolicyPage;
